import { usePostHog } from "posthog-js/react";

// Hook pour utiliser PostHog dans les composants
export const usePostHogEvents = () => {
  const posthog = usePostHog();

  const trackCustomRequest = (data: {
    chefType: string;
    date: string;
    city: string;
    guestCount: number;
    budget: number;
    email: string;
    fullName: string;
  }) => {
    // Identifier l'utilisateur par email
    posthog.identify(data.email, {
      name: data.fullName,
      email: data.email,
    });

    // Capturer l'�v�nement custom request
    posthog.capture("custom_request_submitted", {
      chef_type: data.chefType,
      date: data.date,
      city: data.city,
      guest_count: data.guestCount,
      budget: data.budget,
      timestamp: new Date().toISOString(),
    });
  };

  const trackBookingPayment = (data: {
    email: string;
    date: string;
    city: string;
    guests: number;
    chefId?: number;
    menuId?: number;
  }) => {
    // Identifier l'utilisateur par email
    posthog.identify(data.email);

    // Capturer l'événement de paiement
    posthog.capture("booking_payment_initiated", {
      email: data.email,
      booking_date: data.date,
      city: data.city,
      guest_count: data.guests,
      chef_id: data.chefId,
      menu_id: data.menuId,
      timestamp: new Date().toISOString(),
    });
  };

  return {
    trackCustomRequest,
    trackBookingPayment,
  };
};
